export const contacts = [
  {
    path: '/contacts',
    name: 'Contacts',
    component: () => import('./index.vue'),
    meta: {
      rule: 'CONTANT_PANEL',
      requiredAuth: true,
      title: 'general.contacts',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.contacts',
          disabled: true,
          href: '#/contacts'
        }
      ]
    }
  },
]